/**
 *    @author:
 *    @since:
 *
 */

import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { IValidator } from '../../_common/component/IValidator';
import { BirthdayComponent} from './birth-day.component';

export class BirthdayValidation extends IValidator {
      private success: boolean;
       constructor(private component: BirthdayComponent) { super();
            this.viewportScroller = this.component.viewportScroller; }
       
       private viewportScroller:ViewportScroller;
       public validate(): boolean {
          this.success = true;
          let birthDay = this.component.input;
          let values = birthDay.split("-");

          if(Util.isEmpty(birthDay) || values[0] == '0' || values[1] == '0' || values[2] == '0') {
               if(Util.isEmpty(this.component.eligibility.isBornInOntario)){
                  this.component.error_birthDay = "setup_1.emptyDate";
               } else {
                  this.focus("whenChildBorn","select_date_birthday").error_birthDay = "setup_1.emptyDate";
               }
          }
          else if ( 
               Util.isValidDateStr(birthDay) == false ) {
            if(Util.isEmpty(this.component.eligibility.isBornInOntario)){
               this.component.error_birthDay = "setup_1.invalidDate"; 
            } else {
               this.focus("whenChildBorn","select_date_birthday").error_birthDay = "setup_1.invalidDate"; 
            }
          }
          else  if ( Util.isEligible(birthDay) == Util.FUTURE_DATE ) {
            if(Util.isEmpty(this.component.eligibility.isBornInOntario)){
               this.component.error_birthDay = "setup_1.futureDate";
            } else {
               this.focus("whenChildBorn","select_date_birthday").error_birthDay = "setup_1.futureDate";
            }
          }

          return  this.success;
       }

       private focus(tagId:string,ctrlId:string) : BirthdayComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }
}

